import { enqueueActions } from 'xstate';

import { findSelectedProduct, getCustomizationInput } from '../../helpers';
import { type BundleMachineAction, type SelectionParams } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Replaces the customization machine of a product that timed out or crashed,
 * so the next add starts from a fresh one.
 */
export const restartProductCustomization: BundleMachineAction<SelectionParams> = enqueueActions(
  (args, params: SelectionParams) => {
    const { context, enqueue } = args;
    const { selectionId } = params;

    const selectedProduct = findSelectedProduct({
      selectedProducts: context.selectedProducts,
      selectionId,
    });

    if (!selectedProduct) return;

    enqueue.stopChild(selectedProduct.selectionId);
    enqueue.spawnChild('customization', {
      id: selectedProduct.selectionId,
      input: getCustomizationInput({ context, selectedProduct }),
    });
  },
);
